export const createTask = async () => {
    const response = await fetch("https://genfashioneeg.medien.ifi.lmu.de/api/create_task", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
    });
    return response.json();
};

export const getTaskData = async (taskId) => {
    const response = await fetch(`https://genfashioneeg.medien.ifi.lmu.de/api/ratings/${taskId}`);
    return response.json();
};

export const getInitialImages = async (taskId) => {
    const response = await fetch(`https://genfashioneeg.medien.ifi.lmu.de/api/get_initial_images/${taskId}`);
    return response.json();
};

export const submitRating = async (ratingData) => {
    const response = await fetch("https://genfashioneeg.medien.ifi.lmu.de/api/ratings", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(ratingData),
    });
    return response.json();
};

export const getTaskImages = async (taskId, iterationNum) => {
    const response = await fetch(`https://genfashioneeg.medien.ifi.lmu.de/api/task_images/${taskId}/${iterationNum}`);
    return response.json();
};

export const deleteAllTasks = async () => {
    const response = await fetch("https://genfashioneeg.medien.ifi.lmu.de/api/delete_all_taskIDs", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
    });
    return response.json();
};

export const sendLSLMarker = async (marker) => {
    try {
        await fetch('https://genfashioneeg.medien.ifi.lmu.de/api/ratings/marker', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ marker: marker }),
        });
        console.log(`Marker sent: ${marker}`);
        return true;
    } catch (error) {
        console.error('Error connecting to marker server:', error);
        return false;
    }
};
  

export const saveTaskDuration = async (taskId, duration) => {
    try {
        const response = await fetch(`https://genfashioneeg.medien.ifi.lmu.de/api/save_duration/${taskId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ duration }),
        });

        const data = await response.json();

        if (data.error) {
            throw new Error(data.error);
        }

        return data;
    } catch (error) {
        console.error("Fehler beim Speichern der Timer-Dauer:", error);
        throw error;
    }
};
  